import { render, staticRenderFns } from "./RedirectParameters.vue?vue&type=template&id=698bf79f"
import script from "./RedirectParameters.vue?vue&type=script&lang=js"
export * from "./RedirectParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports